// providers
import { trans } from "@/_providers/Translation"

// libraries
import { Checkbox, FormControlLabel } from "@mui/material"

export default function TaskInfoInvoiceFields({
  task,
  handleInputChange,
  withInvoice,
  handleWithInvoiceChange,
}) {
  return (
    <>
      <div className="row">
        <div className="col">
          <FormControlLabel
            control={
              <Checkbox
                name="with_invoice"
                value="1"
                checked={withInvoice}
                onChange={(e) => handleWithInvoiceChange(e.target.checked)}
                size="small"
              />
            }
            label={trans('labels.invoiceIssue')}
          />
        </div>
      </div>
      {withInvoice ? (
        <>
          <div className="row">
            <div className="col">
              <label htmlFor="invoice_name">
                {trans("labels.nameForInvoice")}*
              </label>
              <input
                value={
                  task.data && task.data.invoice_name
                    ? task.data.invoice_name
                    : ""
                }
                type="text"
                name="invoice_name"
                id="invoice_name"
                disabled={task.data.is_child || !task.data.can_modify}
                onChange={handleInputChange}
                className={task.validations.invoice_name ? "validate" : ""}
              />
            </div>
            <div className="col">
              <label htmlFor="invoice_eikegn">{trans("labels.eikEgn")}*</label>
              <input
                value={
                  task.data && task.data.invoice_eikegn
                    ? task.data.invoice_eikegn
                    : ""
                }
                type="text"
                name="invoice_eikegn"
                id="invoice_eikegn"
                disabled={task.data.is_child || !task.data.can_modify}
                onChange={handleInputChange}
                className={task.validations.invoice_eikegn ? "validate" : ""}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="invoice_vat_number">
                {trans("labels.vatNo")}
              </label>
              <input
                value={
                  task.data && task.data.invoice_vat_number
                    ? task.data.invoice_vat_number
                    : ""
                }
                type="text"
                name="invoice_vat_number"
                id="invoice_vat_number"
                disabled={task.data.is_child || !task.data.can_modify}
                onChange={handleInputChange}
                className={
                  task.validations.invoice_vat_number ? "validate" : ""
                }
              />
            </div>
            <div className="col">
              <label htmlFor="invoice_mom">{trans("labels.mol")}*</label>
              <input
                value={
                  task.data && task.data.invoice_mol
                    ? task.data.invoice_mol
                    : ""
                }
                type="text"
                name="invoice_mol"
                id="invoice_mol"
                disabled={task.data.is_child || !task.data.can_modify}
                onChange={handleInputChange}
                className={task.validations.invoice_mol ? "validate" : ""}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="invoice_address">
                {trans("labels.address")}*
              </label>
              <input
                value={
                  task.data && task.data.invoice_address
                    ? task.data.invoice_address
                    : ""
                }
                type="text"
                name="invoice_address"
                id="invoice_address"
                disabled={task.data.is_child || !task.data.can_modify}
                onChange={handleInputChange}
                className={task.validations.invoice_address ? "validate" : ""}
              />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  )
}
